/**
 * servicing eapi
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

export interface FareConditionsResponseDataAirOfferConditionsAirOfferConditionBoundsInner {
  /**
   * 運賃ルール用のバウンドの1便目の出発空港コード
   */
  originLocationCode?: string;
  /**
   * DxAPIから返却された運賃ルール用のバウンドの1便目の出発空港名称
   */
  originLocationName?: string;
  /**
   * 運賃ルール用のバウンドの最終便の到着空港コード
   */
  destinationLocationCode?: string;
  /**
   * DxAPIから返却された運賃ルール用のバウンドの最終便の到着空港名称
   */
  destinationLocationName?: string;
  /**
   * Fare Familyコード
   */
  fareFamilyCode?: string;
  /**
   * Fare Basis
   */
  fareBasis?: string;
  /**
   * Priority Code<br/> 1.カート情報をもとに設定する場合、Fare Family Codeの下4桁を設定する。<br/> 2.PNR情報取得APIのレスポンス、または予約変更リソースをもとに設定する場合、<br/> Fare Family Codeに設定されるBrand Codeをもとに、ASWDB(マスタ)から取得したPriority Codeを設定する。
   */
  priorityCode?: string;
  /**
   * 特典種別<br/> 特典PNRの場合のみ返却する。<br/> nhInt: NH特典(国際線)。Fare Basisの末尾がNH特典(国際線)のもの(設定ファイルに定義)<br/> dom: NH特典(国内線)。Fare Basisの末尾がNH特典(国内線)のもの(設定ファイルに定義)<br/> starAlliance: スターアライアンス提携特典。Fare Basisの末尾が\"ST\"、\"STC\"または\"ST2\"<br/> otherAirline: 単一提携航空会社特典。上記以外。
   */
  awardType?: FareConditionsResponseDataAirOfferConditionsAirOfferConditionBoundsInner.AwardTypeEnum;
  /**
   * シーズナリティ<br/> Fare Basisの2文字目<br/> 特典種別が存在し、かつNH特典の場合のみ返却する。
   */
  seasonality?: string;
}
export namespace FareConditionsResponseDataAirOfferConditionsAirOfferConditionBoundsInner {
  export type AwardTypeEnum = 'nhInt' | 'starAlliance' | 'dom' | 'otherAirline';
  export const AwardTypeEnum = {
    NhInt: 'nhInt' as AwardTypeEnum,
    StarAlliance: 'starAlliance' as AwardTypeEnum,
    Dom: 'dom' as AwardTypeEnum,
    OtherAirline: 'otherAirline' as AwardTypeEnum,
  };
}
